import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';
import { Collapse } from 'antd';
import { DownOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });




  return text ? (
    <section className={css.sectionText}>

<Collapse
    bordered={false}
    expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
  >
    <Panel header="Description" key="1" >
    {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
    </Panel>
  </Collapse>

    </section>
  ) : null;
};

export default SectionTextMaybe;
